import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static targets = ["search", "status", "objectCreated", "carrier", "brokerage", "effectiveFrom", "effectiveTo"]

    // Stimulus 2 has no keyboard event filters (`keyup.enter`), so the key is checked here.
    filterOnEnter(event) {
        if (event.key !== "Enter") return

        this.filter()
    }

    filter() {
        const filters = {
            search: this.searchTarget.value,
            status: this.statusTarget.value,
            object_created: this.objectCreatedTarget.value,
            carrier: this.carrierTarget.value,
            // The brokerage select is only rendered when the admin can reach more than one.
            brokerage_id: this.hasBrokerageTarget ? this.brokerageTarget.value : "",
            effective_from: this.effectiveFromTarget.value,
            effective_to: this.effectiveToTarget.value
        }
        this.stimulate("PolicyReflex#filter", filters);
    }
}
